import {
  zlbApiExpenseWorkPlanInfoWorkPlanCodeGet,
  zlbApiExpenseWorkPlanPagePost,
} from 'src/api/zlbExpense';

export default {
  namespace: 'workPlan',
  state: {
    userTypeList: [],
    workPlanDetail: {},
    // 选择工作计划弹窗字段
    selectList: [], // 已选择的工作计划
    businessType: '', // 已选择的出差类型
  },
  effects: {
    *getWorkPlanList({ payload }, { call }) {
      const result = yield call(zlbApiExpenseWorkPlanPagePost, payload);
      return result;
    },
    *getWorkPlanInfo({ payload }, { call, put }) {
      const result = yield call(zlbApiExpenseWorkPlanInfoWorkPlanCodeGet, {
        workPlanCode: payload.workPlanCode,
      });
      yield put({
        type: 'update',
        payload: {
          workPlanDetail: result || {},
        },
      });
      return result;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
